import { Slide } from "@jelly/lesson";

import correlation from "./components/correlation";
import sound from "./components/sound";
import validation from "./components/validation";

const principle: Slide = {
  title: "Metric Development",
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [{ name: "Correlation" }, { name: "Sound Quality Metric Development" }, { name: "Validation" }],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [[], [], []],
      components: [correlation, sound, validation],
    },
  },
};

export default principle;
